export const CREATE_ANNOTATION_REQUEST = "CREATE_ANNOTATION_REQUEST";
export const CREATE_ANNOTATION_REQUEST_SUCCESS = "CREATE_ANNOTATION_REQUEST_SUCCESS";
export const CREATE_ANNOTATION_REQUEST_FAILED = "CREATE_ANNOTATION_REQUEST_FAILED";